import * as React from 'react';
import * as ReactModal from 'react-modal';
import { Modal as BootstrapModal } from "react-bootstrap";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
    },
};

class ModalForm extends React.Component<any, any> {
    render() {
        return (
            <div>
                {/* @ts-ignore */}
                <ReactModal
                    isOpen={this.props.isOpen}
                    onRequestClose={this.props.onRequestClose}
                    appElement={document.getElementById('root') ?? undefined}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    {/* @ts-ignore */}
                    {this.props.modalHeader ? <BootstrapModal.Header>{this.props.modalHeader}</BootstrapModal.Header> : null}

                    {/* @ts-ignore */}
                    <BootstrapModal.Body>{this.props.children}</BootstrapModal.Body>

                    {/* @ts-ignore */}
                    {this.props.modalFooter ? <BootstrapModal.Footer>{this.props.modalFooter}</BootstrapModal.Footer> : null}
                </ReactModal>
            </div>
        )
    }
}

export default ModalForm;
